import { ButtonSizeType } from '../Button.types';

export const size: Record<ButtonSizeType, string> = {
  regular: `
    font-size: 1rem;
    font-weight: 600;
    height: 3.75rem;
    min-width: 12.5rem;
  `,
  small: `
    font-size: 0.875rem;
    font-weight: 600;
    height: 2.25rem;
    min-width: 8.125rem;
  `,
  extraSmall: `
    border-radius: 4px !important;
    font-size: 0.625rem;
    font-weight: 500;
    height: 1.5rem;
    min-width: 4.25rem;
  `,
};
